<template>
  <div class="html">
    <banner
      :title="title"
      :content="content"
    />
    <div class="service_method">
      <p class="sub_title">
        服务内容
      </p>
      <div class="service_method_content">
        <div class="method_content">
          <div class="left_img1 word_style">
            检查安全设备状态
          </div>
          <div class="content_item1 content_item">
            <div>
              查看运行状态、查看版本升级 优化配置策略
            </div>
          </div>
        </div>
        <div class="method_content">
          <div class="content_item2 content_item_even">
            <div>
              定期为客户信息系统的日志进行深度挖掘和分析，发现潜在的风险点，及时掌握网络运行状态和安全隐患
            </div>
          </div>
          <div class="right_img1 word_style">
            安全日志分析
          </div>
        </div>
        <div class="method_content">
          <div class="left_img2 word_style">
            安全漏洞扫描
          </div>
          <div class="content_item3 content_item">
            <div>
              对信息系统进行漏洞扫描，并根据扫描结果进行综合分析并提供可行的漏洞解决方案
            </div>
          </div>
        </div>
        <div class="method_content">
          <div class="content_item4 content_item_even">
            <div>
              对存在严重系统漏洞的主机进行补丁更新，
              从而及时消除因为系统漏洞而产生的安全风险
            </div>
          </div>
          <div class="right_img2 word_style">
            补丁管理
          </div>
        </div>
      </div>
    </div>
    <div class="introduces bg_color">
      <p class="sub_title">
        服务流程
      </p>
      <div class="lists">
        <div
          v-for="(item, index) in processList"
          :key="index"
          class="list_T"
        >
          <div class="item_list1">
            <div class="title">
              {{ item.title }}
            </div>
            <div class="content">
              <div class="content_left1">
                <div>
                  <div>STEP</div>
                  <div>0{{ index + 1 }}</div>
                </div>
              </div>
              <div class="content_right1">
                <div class="content_right_item">
                  <div v-if="item.content">
                    {{ item.content }}
                  </div>
                  <div
                    v-for="list in item.list"
                    :key="list"
                  >
                    <li>{{ list }}</li>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="introduces">
      <p class="sub_title">
        服务价值
      </p>
      <div class="lists">
        <div
          v-for="item in worthList"
          :key="item.id"
          class="list"
        >
          <div class="item_list">
            <div class="img">
              <img
                :src="item.img"
                alt=""
              >
            </div>
            <div class="content">
              <div
                v-for="list in item.list"
                :key="list"
              >
                {{ list }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import banner from '@/views/securityServices/components/banner.vue'
export default {
  name: 'Inspection',
  components: {
    banner
  },
  data() {
    return {
      title: '安全巡检服务',
      content:
        '安全巡检作为主动运维的一种手段， 可以提前发现问题。 将主动发现安全隐患来代替被动解决安全问题，极大的提高信息系统安全防护水平。 安全服务团队将根据等级保护要求， 定期对各类异构安全设备进行全面的安全巡检， 一旦发现问题， 配套提供各类专业安全解决方案。',

      processList: [
        {
          id: 1,
          img: require('@/assets/securityServices/training5.png'),
          title: '前期准备阶段',
          content: '和客户提前约定巡检时间。',
          list: ['确定范围', '确定明细', '确定时间']
        },
        {
          id: 2,
          img: require('@/assets/securityServices/training6.png'),
          title: '安全监测实战阶段',
          content: '巡检人员对信息系统进行巡检，遇到问题，现场处理，截图留档',
          list: []
        },
        {
          id: 3,
          img: require('@/assets/securityServices/training7.png'),
          title: '总结阶段',
          content: '信息整理并形成报告',
          list: []
        }
      ],
      worthList: [
        {
          id: 1,
          img: require('@/assets/securityServices/training1.png'),
          list: ['查漏补缺，避免隐患变为事故']
        },
        {
          id: 2,

          img: require('@/assets/securityServices/training2.png'),
          list: ['了解、掌握目前网络、系统安全状况和风险防范']
        },
        {
          id: 3,
          img: require('@/assets/securityServices/training3.png'),
          list: ['及时发现漏洞将问题闭环处理']
        },
        {
          id: 4,
          img: require('@/assets/securityServices/training4.png'),
          list: ['保障系统、设备的安全和高可用性']
        }
      ]
    }
  }
}
</script>
<style scoped>
@import '../../styles/utils.scss';
</style>
<style lang="less" scoped>
.service_method {
  width: 100%;
  margin: 82px auto;
  .service_method_content {
    width: 70%;
    margin: 93px auto 0;
    .method_content {
      display: flex;
      justify-content: space-between;
      width: 60%;
      position: relative;
      .content_item {
        position: absolute;
        top: 38px;
        left: 257px;
        width: 100%;
        z-index: -1;
        border-radius: 20px;

        div {
          height: 134px;
          border-radius: 20px;
          width: 80%;
          margin: 0 auto;
          display: flex;
          align-items: center;
          font-size: 24px;
          font-weight: bold;
          color: #666666;
          line-height: 40px;
        }
      }
      .content_item_even {
        position: absolute;
        top: 38px;
        right: 257px;
        width: 100%;
        z-index: -1;
        border-radius: 20px;

        div {
          height: 134px;
          border-radius: 20px;
          width: 80%;
          margin: 0 auto;
          display: flex;
          align-items: center;
          font-size: 24px;
          font-weight: bold;
          color: #666666;
          line-height: 40px;
        }
      }
      .content_item1 {
        background: #dae9fc;
      }
      .content_item2 {
        background: #e2f7f8;
      }
      .content_item3 {
        background: #e1edfc;
      }
      .content_item4 {
        background: #e9ebf7;
      }
      .word_style {
        width: 311px;
        height: 172px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 28px;
        font-weight: bold;
        color: #ffffff;
        line-height: 40px;
      }
      .left_img1 {
        background-image: url('~@/assets/securityServices/inspection1.png');
      }
      .left_img2 {
        background-image: url('~@/assets/securityServices/inspection3.png');
      }
      .right_img1 {
        position: absolute;
        right: 0;
        background-image: url('~@/assets/securityServices/inspection2.png');
      }
      .right_img2 {
        position: absolute;
        right: 0;
        background-image: url('~@/assets/securityServices/inspection4.png');
      }
    }
    .method_content:nth-child(even) {
      width: 60%;
      margin-left: 40%;
      margin-top: 0;
    }
    .method_content:nth-child(odd) {
      margin-top: 180px;
    }
  }
}
@media (max-width: 1700px) {
  .method_content:nth-child(even) {
    margin-top: 20px !important;
  }
  .method_content:nth-child(odd) {
    margin-top: 190px !important;
  }
}
.introduces {
  width: 100%;
  margin: 82px auto;

  .title {
    width: 80%;
    margin: 0 auto;
    font-size: 20px;
  }
  .lists {
    width: 70%;
    margin: 0 auto;
    margin-top: 66px;
    display: flex;
    justify-content: space-between;

    .list {
      width: 28%;
      margin-top: 30px;
      margin: 0 1%;
      background: #fff;
      box-shadow: 0 0 50px #ddefff;

      .item_list {
        width: 100%;
        .img {
          text-align: center;
          padding-top: 88px;
          img {
            width: 175px;
            height: auto;
          }
        }
        .content {
          width: 80%;
          margin: 89px auto 133px;

          div {
            text-align: center;
            font-size: 24px;
            font-weight: 400;
            color: #666666;
            line-height: 40px;
          }
        }
      }
    }
    .list_T {
      width: 30%;
      margin-top: 30px;
      margin: 0 1%;
      background: #fff;
      box-shadow: 0 0 50px #ddefff;
      border-radius: 30px;

      .item_list1 {
        width: 100%;
        .title {
          margin-top: 60px;
          font-size: 24px;
          font-weight: bold;
          color: #333333;
          line-height: 40px;
          text-align: center;
        }
        .content {
          width: 100%;
          margin-top: 11px;
          display: flex;
          justify-content: space-between;
          min-height: 300px;

          .content_left1 {
            width: 120px;
            height: 200px;
            background-color: red;
            border-radius: 0 100px 100px 0;
            display: flex;
            align-items: center;
            background: linear-gradient(to bottom, #4d81ea, #72b0f5);
            div {
              display: flex;
              flex-direction: column;
              font-weight: bold;
              color: #ffffff;
              line-height: 40px;
              padding-left: 5px;

              div:nth-child(1) {
                font-size: 28px;
              }
              div:nth-child(2) {
                font-size: 60px;
                margin-top: 5px;
              }
            }
          }
          .content_right1 {
            width: calc(100% - 100px);
            margin-top: 20px;

            .content_right_item {
              text-align: left;
              margin: 0 10%;
              font-size: 20px;
              font-weight: 400;
              color: #666666;
              line-height: 40px;
            }
          }
        }
      }
    }
  }
}
.bg_color {
  background: #fafbff;
  padding: 68px 0 104px;
  margin-top: 280px;
}

@media (min-width: 1200px)and (max-width: 1350px){
  .service_method .sub_title{
    font-size: 35px;
  }

  .introduces .lists .list .item_list .content div{
    font-size: 20px;
  }
}
@media (min-width: 1350px)and (max-width: 1500px){
  .service_method .sub_title{
    font-size: 35px;
  }
  .introduces .lists .list .item_list .content div{
    font-size: 22px;
  }
}
</style>
